import { AdminShell } from "@project/admin/components/admin-shell";
import { ApiResourceTable } from "@project/admin/components/api-resource-table";
import type { Field } from "@project/admin/components/resource-table";
import { contactFormService } from "@project/services/admin/contact-form.service";
import {
  CONTACT_FORM_STATUS_OPTIONS,
  type ContactFormPayload,
  type ContactFormRecord,
  type ContactFormStatus,
} from "@project/types/contact-form";

const statusOptions = CONTACT_FORM_STATUS_OPTIONS.map(o => ({
  value: o.value,
  label: o.label,
}));

const fields: Field[] = [
  { name: "full_name", label: "Name", required: true, showInTable: true },
  { name: "mobile", label: "Mobile", type: "tel", showInTable: true },
  { name: "email", label: "Email", type: "email", showInTable: true },
  { name: "subject", label: "Subject", showInTable: true },
  {
    name: "message",
    label: "Message",
    type: "textarea",
    required: true,
    hideInTable: true,
  },
  {
    name: "status",
    label: "Status",
    type: "select",
    options: statusOptions,
    showInTable: true,
  },
];

function toPayload(payload: Record<string, unknown>): ContactFormPayload {
  return {
    full_name: String(payload.full_name ?? "").trim(),
    mobile: payload.mobile ? String(payload.mobile).trim() : undefined,
    email: payload.email ? String(payload.email).trim() : undefined,
    subject: payload.subject ? String(payload.subject).trim() : undefined,
    message: String(payload.message ?? "").trim(),
    status: payload.status
      ? (String(payload.status) as ContactFormStatus)
      : undefined,
  };
}

export default function Page() {
  return (
    <AdminShell title="Contact Inquiries" subtitle="From public website">
      <ApiResourceTable<ContactFormRecord>
        title="Inquiry"
        labelField="full_name"
        fields={fields}
        searchFields={["full_name", "mobile", "email", "subject"]}
        defaultValues={{ status: "open" }}
        enableCsvExport
        csvFileName="contact-inquiries"
        editOnlyFields={["status"]}
        list={query => contactFormService.listContactFormsPage(query)}
        create={payload => contactFormService.create(toPayload(payload))}
        update={(id, payload) =>
          contactFormService.update(id, {
            status: payload.status
              ? (String(payload.status) as ContactFormStatus)
              : undefined,
          })
        }
        remove={id => contactFormService.delete(id)}
      />
    </AdminShell>
  );
}
